<template>
    <div class="input-group-btn">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {}
    };
</script>



// WEBPACK FOOTER //
// input-group-button.vue?4ecde3cf